$(document).on('click', '.js-ajax-link', function (event) {
  // if canceled confirm
  if (event.isDefaultPrevented()) {
    return
  }

  event.preventDefault()

  const that = this

  spiral.ajax({
    url: $(this).attr('href'),
    processAnswer: function (result) {
      if (result.isSuccess) {
        const fn = window[$(that).attr('data-callback')]

        if (typeof (fn) === 'function') {
          fn.call(that, result)
        }
      } else {
        alert(result.response)
      }
    },
  })
})
